import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      Coded by WadzanayiK and{" "}
      <a
        href="https://github.com/WadzanayiK/week5react"
        target="_blank"
        rel="noopener noreferrer"
      >
        open sourced on Github
      </a>
      {/* <br />
      Weather icons created by{" "}
      <a
        href="https://www.flaticon.com/free-icons/weather"
        title="weather icons"
        target="_blank"
        rel="noopener noreferrer"
      >
        iconixar - Flaticon
      </a> */}
  </div>
  );
}